/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { SHOW_MEMBER_METADATA_POPUP, MEMBER_METADATA_UPDATED } from "../isomorphic/constants";
import { getCookie } from "../isomorphic/utils";

const getEnableDarkModeCookie = getCookie("enableDarkMode") || false;
const checkDarkModeEnabled = getEnableDarkModeCookie === "true";

function headerReducer(
  state = {
    isSidebarVisible: false,
    isSearchFormVisible: false,
    primarySubmenu: null,
    isMegaMenuVisible: false,
    isDarkModeEnabled: checkDarkModeEnabled,
  },
  action
) {
  switch (action.type) {
    case "TOGGLE_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: !state.isSidebarVisible };
    case "OPEN_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: true };
    case "CLOSE_SIDEBAR_MENU":
      return { ...state, isSidebarVisible: false };
    case "TOGGLE_SEARCHFORM":
      return { ...state, isSearchFormVisible: !state.isSearchFormVisible };
    case "CLOSE_SEARCHFORM":
      return { ...state, isSearchFormVisible: false };
    case "OPEN_PRIMARY_SUBMENU":
      return { ...state, primarySubmenu: action.payload.menuId };
    case "CLOSE_PRIMARY_SUBMENU":
      return { ...state, primarySubmenu: null };
    case "TOGGLE_MEGAMENU":
      return { ...state, isMegaMenuVisible: !state.isMegaMenuVisible };
    case "TOGGLE_DARK_MODE":
      return { ...state, isDarkModeEnabled: action.isDarkModeEnabled };
    case "CLOSE_ALL":
      return {
        ...state,
        isSidebarVisible: false,
        isSearchFormVisible: false,
        primarySubmenu: null,
        isMegaMenuVisible: false,
      };
    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case "OPEN_LOGIN_TEMPLATE":
      return true;
    case "CLOSE_LOGIN_TEMPLATE":
      return false;
    default:
      return state;
  }
}

function meteringIndicatorReducer(state = true, action) {
  switch (action.type) {
    case "SHOW_METERING_INDICATOR":
      return true;
    case "HIDE_METERING_INDICATOR":
      return false;
    default:
      return state;
  }
}

function memberSubscriptionsReducer(state = [], action) {
  switch (action.type) {
    case "MEMBER_SUBSCRIPTIONS_UPDATED":
      if (action && action.subscriptions) {
        return [...action.subscriptions];
      }
      return [];
    default:
      return state;
  }
}

function memberMetadataReducer(state = { showMemberMetadataPopup: true, isMemberMetadataUpdated: false }, action) {
  switch (action.type) {
    case SHOW_MEMBER_METADATA_POPUP:
      return { ...state, showMemberMetadataPopup: action.showMemberMetadataPopup };
    case MEMBER_METADATA_UPDATED:
      return { ...state, isMemberMetadataUpdated: action.isMemberMetadataUpdated };
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case "MEMBER_UPDATED":
      return action.member;
    default:
      return state;
  }
}

function memberEmailReducer(state = null, action) {
  switch (action.type) {
    case "MEMBER_EMAIL_UPDATED":
      return action.userEmail;
    default:
      return state;
  }
}

export const CUSTOM_REDUCERS = {
  header: headerReducer,
  isLoginOpen: loginReducer,
  showMeteringIndicator: meteringIndicatorReducer,
  memberSubscriptions: memberSubscriptionsReducer,
  member: memberReducer,
  memberEmail: memberEmailReducer,
  memberMetadata: memberMetadataReducer,
};
